import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import urlon from "components/hooks/customUrlon";

const parseQuery = (obj) => {
  if (obj === "" || obj === "?") return {};
  if (obj.startsWith("?")) obj = obj.slice(1);
  try {
    urlon.parse(obj);
  } catch (e) {
    console.error("Error parsing query string:", e);
    return {};
  }
  return urlon.parse(obj);
};

export const toQuery = (data) => {
  return urlon.stringify(data);
};

export const toQueryString = (data) => {
  const query = toQuery(data);
  return query === "$" ? "" : `?${query}`;
};

const useQueryStringState = (defaultOptions) => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = useMemo(
    () => ({ ...defaultOptions, ...parseQuery(location.search) }),
    [location.search],
  );

  const setState = useCallback(
    (newState, options) => {
      let nextState = newState;
      if (typeof newState === "function") nextState = newState(state);

      let nextStateClean = {};
      Object.entries(nextState).map(([key, value]) => {
        if (value !== undefined && value !== "") {
          nextStateClean[key] = value;
        }
      });

      let query = toQuery(nextStateClean);
      if (query === "$") query = "";

      if (location.search !== query && location.search !== `?${query}`) {
        navigate(
          {
            pathname: location.pathname,
            search: query,
          },
          {
            replace: false, // or true if you want to replace history entry
            ...defaultOptions,
            ...options,
          },
        );
      }
    },
    [location, navigate, state],
  );

  return [state, setState];
};

export default useQueryStringState;
